import { create } from 'zustand'

/**
 * What the sync badge shows.
 *
 * Kept in its own store rather than in the app store on purpose: it is not
 * persisted, it changes far more often than the data, and a component that
 * only watches the badge should not re-render when a box is ticked.
 *
 * `no-household` is the one phase `../semainier` does not have. A signed-in
 * user whose membership could not be resolved can neither pull nor push, and
 * saying "déconnectée" would be a lie that sends them to a login screen they
 * are already past.
 */
export type SyncPhase =
  | 'idle'
  | 'syncing'
  | 'offline'
  | 'error'
  | 'signed-out'
  | 'no-household'
  | 'disabled'

interface SyncState {
  phase: SyncPhase
  /** Local changes not yet accepted by the server. */
  pending: number
  lastSyncAt: string | null
  lastError: string | null
  set: (patch: Partial<Omit<SyncState, 'set'>>) => void
}

export const useSyncStatus = create<SyncState>()((set) => ({
  phase: 'disabled',
  pending: 0,
  lastSyncAt: null,
  lastError: null,
  set: (patch) => set(patch),
}))

export const setSyncStatus = (patch: Partial<Omit<SyncState, 'set'>>): void =>
  useSyncStatus.getState().set(patch)
